// 礼物卡（EP-008-S3 / GDD 03 §②-2 / ⑥-S12）。
// 已获得：彩图 + 名称 + 角标点数 + 数量角标；未获得：剪影 + 名称 + 角标（不显示 desc，B3）。
// 圆角 20px、描边 1.5px N3 #C4B49F（C6）。点击开 ItemDetail。
import { assetIndex, type AssetId } from '../assets/assetIndex';
import { GIFT_BY_ID } from '../domain/gifts/giftDef';
import { RARITY_TIER, RARITY_NAME_BY_TIER } from '../runtime/sequencer';
import { RarityDots } from './RarityDots';
import { CountBadge } from './CountBadge';
import { Silhouette } from './Silhouette';

interface ItemCardProps {
  giftId: string;
  count: number;
  obtained: boolean;
  /** 🆕 P6-POLISH-ENG-002 §F：未读（首次获得且未在详情页打开过）的礼物显示「新」标记 + 高亮描边。
   *  语义 = `stack.isRead === false`，与礼物 tab 角标数字同源（角标 N ↔ 网格中恰好 N 张带标记）。 */
  isNew?: boolean;
  onOpen?: (giftId: string) => void;
}

export function ItemCard({ giftId, count, obtained, isNew = false, onOpen }: ItemCardProps) {
  const def = GIFT_BY_ID[giftId];
  const name = def?.name ?? giftId;
  const tier = def ? RARITY_TIER[def.rarity] : 1;
  const src = assetIndex[('gift_' + giftId) as AssetId];

  const label = obtained
    ? `${name}，稀有度 ${RARITY_NAME_BY_TIER[tier]}，持有 ${count} 个${isNew ? '，新获得' : ''}`
    : `${name}，尚未获得`;

  return (
    <button
      type="button"
      className={isNew ? 'item-card item-card--new' : 'item-card'}
      aria-label={label}
      disabled={!onOpen}
      onClick={onOpen ? () => onOpen(giftId) : undefined}
    >
      {isNew && (
        // 🆕 §F.2 通道①：「新」文字角标（左上角），bg 用 --a3（强调橙深，可承载文字 5.44:1 AA），
        // 文字用 --text-on-action。与右上角数量角标对角分布，互不遮挡。
        <span className="item-card__new-badge" aria-hidden="true">
          新
        </span>
      )}
      {obtained ? (
        <img className="item-card__img" src={src} alt="" loading="lazy" aria-hidden="true" />
      ) : (
        <Silhouette giftId={giftId} />
      )}
      <span className="item-card__name">{name}</span>
      <RarityDots tier={tier} />
      {obtained && <CountBadge count={count} />}
    </button>
  );
}
